import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { userApi } from '@/api/user'
import type { UserInfo } from '@/types'
import { setWechatOpenid } from '@/api/payment'

export const useUserStore = defineStore('user', () => {
  const token = ref<string>(localStorage.getItem('token') || '')
  const userInfo = ref<UserInfo | null>(null)

  const isLoggedIn = computed(() => !!token.value)

  // 登录
  async function login(username: string, password: string) {
    const res = await userApi.login({ username, password })
    token.value = res.token
    userInfo.value = res.userInfo
    localStorage.setItem('token', res.token)
    return res
  }

  // 注册
  async function register(data: { username: string; password: string; phone: string; inviteCode?: string }) {
    const res = await userApi.register(data)
    token.value = res.token
    localStorage.setItem('token', res.token)
    return res
  }

  // 获取用户信息
  async function getUserInfo() {
    const res = await userApi.getProfile()
    userInfo.value = res
    return res
  }

  // 退出登录
  function logout() {
    token.value = ''
    userInfo.value = null
    localStorage.removeItem('token')
    localStorage.removeItem('wechat_openid')
  }

  // 更新用户信息
  function updateUserInfo(info: Partial<UserInfo>) {
    if (userInfo.value) {
      userInfo.value = { ...userInfo.value, ...info }
    }
  }

  // 微信登录
  async function wechatLogin(code: string, state?: string) {
    const res = await userApi.wechatLogin({ code, state })
    token.value = res.token
    userInfo.value = res.userInfo
    localStorage.setItem('token', res.token)

    // 保存openid用于支付
    if (res.openid) {
      setWechatOpenid(res.openid)
    }

    return res
  }

  return {
    token,
    userInfo,
    isLoggedIn,
    login,
    register,
    getUserInfo,
    logout,
    updateUserInfo,
    wechatLogin
  }
})
